// extracted by mini-css-extract-plugin
export default {"error":"App_error__7hurn","p":"App_p__p6uQq","pre":"App_pre__YyIlI","button":"App_button__oPcFP"};